import {
  Button,
  Flex,
  Text,
  ButtonGroup,
  Tooltip,
  Icon,
} from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { ASSISTANT_TYPES } from "./constants";
import { useParams } from "react-router-dom";
import { MdInfoOutline } from "react-icons/md";

const AssistantType = ({ voices, voiceSsts }) => {
  const { myDetails, buttonColorScheme } = useContext(AgencyContext);
  const { watch, setValue } = useFormContext();
  const { assistantId } = useParams();

  const selectedType = watch("assistant_type");
  const currentAssistantType = useMemo(
    () => ASSISTANT_TYPES.find((type) => type.type === selectedType),
    [selectedType]
  );

  const handleTypeSelection = (type) => {
    const defaultPrompt = `As an AI assistant built by a team of engineers at ${
      myDetails?.branding?.agency_name || "Algoscale"
    }, please answer the user query with the context provided.`;

    setValue("assistant_type", type);
    setValue("has_human_agent", false);
    setValue("templatePhonePrompt", undefined);
    setValue("custom_voice", false);
    setValue("systemPrompt", watch("systemPrompt") || defaultPrompt);
    setValue(
      "llmModel",
      type !== "realtime_openai"
        ? {
            value: "gpt-3.5-turbo-0125",
            label: "GPT-3.5-Turbo-0125",
          }
        : undefined
    );

    const voice = voices.find(
      ({ language_group }) => language_group === "english"
    );
    const filteredVoiceLanguages = voiceSsts
      .filter(({ locale_code }) => locale_code === "en-US")
      .map(({ name, locale_code, id, language_group, voicestt_provider }) => ({
        label: name,
        value: locale_code,
        id,
        language_group,
        speaker: voice && {
          label: `${voice.name} (${voice.credits}) credits`,
          value: voice.id,
          voicetts_provider: voice.voicetts_provider,
        },
        voicestt_provider,
      }));

    setValue("voiceLanguages", filteredVoiceLanguages);
    setValue("voice", ["simple", "phone"].includes(type));
  };

  return (
    <Flex fontSize="md" justifyContent="flex-start" gap={2} alignItems="center">
      <Text>Assistant Type:</Text>
      <ButtonGroup spacing={0} isAttached>
        {ASSISTANT_TYPES.map(({ children: AssistantIcon, type, title }) => (
          <Button
            key={type}
            title={type}
            isDisabled={assistantId ? true : false}
            onClick={() => handleTypeSelection(type)}
            colorScheme={type === selectedType ? buttonColorScheme : "gray"}
            variant={type === selectedType ? "solid" : "outline"}
            leftIcon={<AssistantIcon />}
          >
            {title}
          </Button>
        ))}
      </ButtonGroup>
      {currentAssistantType && (
        <Tooltip
          label={
            <Flex direction="column" gap={1} p={1}>
              <Text fontWeight="semibold">{currentAssistantType.title}</Text>
              <Text fontSize="xs">{currentAssistantType.subheading}</Text>
            </Flex>
          }
          hasArrow
          placement="right"
          maxW="280px"
        >
          <span>
            <Icon as={MdInfoOutline} boxSize={4} color="gray.400" cursor="help" />
          </span>
        </Tooltip>
      )}
    </Flex>
  );
};

export default AssistantType;
